import styles, { stylesheet } from './LegacyLiveChat.scss'
import onlineIcon from '../../assets/images/online_icon.svg'
import offlineIcon from '../../assets/images/offline_icon.svg'
import chaticon from '../../assets/images/live_chat_icon.svg'
import { withTranslation } from 'react-i18next'
import { Typography, Button, Row, Spinner, ResponsiveImage, Box, FlexBox, tokens } from '@vp/swan'
import { useStyles } from '@vp/ubik-context'

const ChatContent = (props) => {
  const { t, tenant, locale, chatEnabled, buttonId, startChat } = props
  const lng = locale.toLowerCase().replace('-', '_')
  useStyles(stylesheet)
  return (
    <Box paddingRight="2" className={styles.livechatColumnContainer}>
      <Row>
        <div style={{ display: 'flex' }}>
          <Typography component="h3" fontSize="x2large">
            {t(`${tenant}:chat.title`, { lng })}
          </Typography>
        </div>
      </Row>
      <Row id="chat_preloader" style={{ marginBottom: '-80px' }}>
        <FlexBox alignItems="center" justifyContent="center" mt={8} style={{ width: '100%' }}>
          <Spinner accessibleText={t(`${tenant}:search_results.preloader_accessibility_label`, { lng })} size="standard" />
        </FlexBox>
      </Row>
      <Row pt="5">
        <div style={{ display: 'flex' }}>
          <div id="salesforceChatStatusDiv" style={{ display: 'flex' }}>
            <ResponsiveImage role="presentation" id="liveagent_icon_online" style={{ display: 'none' }} aspectratio="1" src={onlineIcon} alt="" width="12px" />
            <Typography fontWeight="bold" component="span" fontSize="large" id="liveagent_title_online" style={{ display: 'none' }} ml="3">
              {t(`${tenant}:pre_footer.links.live_chat.online.status`, '', { lng })}
            </Typography>
            <ResponsiveImage
              role="presentation"
              id="liveagent_icon_offline"
              style={{ display: 'none' }}
              aspectratio="1"
              src={offlineIcon}
              alt=""
              width="12px"
            />
            <Typography fontWeight="bold" component="span" fontSize="large" id="liveagent_title_offline" style={{ display: 'none' }} ml="3">
              {t(`${tenant}:pre_footer.links.live_chat.offline.status`, '', { lng })}
            </Typography>
          </div>
          <div id="forcedOfflineStatus" style={{ display: 'none' }}>
            <ResponsiveImage
              role="presentation"
              id="forcedOfflineIcon"
              style={{ display: !chatEnabled ? 'block' : 'none' }}
              aspectratio="1"
              src={offlineIcon}
              alt=""
              width="12px"
            />
            <Typography
              fontWeight="bold"
              component="span"
              fontSize="large"
              id="forcedOfflineStatus"
              style={{ display: !chatEnabled ? 'block' : 'none' }}
              ml="3"
            >
              {t(`${tenant}:pre_footer.links.live_chat.offline.status`, '', { lng })}
            </Typography>
          </div>
        </div>
      </Row>
      <Row pt="5">
        <div id="salesforceChatDescriptionDiv" style={{ width: '100%' }}>
          <Typography component="span" fontSize="standard" id="liveagent_description_online" style={{ display: 'none' }}>
            {' '}
            {t(`${tenant}:chat.description`, { lng })}{' '}
          </Typography>
          <Typography component="span" fontSize="standard" id="liveagent_description_offline" style={{ display: 'none' }}>
            {' '}
            {t(`${tenant}:chat.buttons.chat_offline.description`, { lng })}{' '}
          </Typography>
        </div>
        <div id="forcedOfflineDescription" style={{ display: 'none', width: '100%' }}>
          <Typography id="forceOfflineDescription" style={{ display: !chatEnabled ? 'block' : 'none' }}>
            {' '}
            {t(`${tenant}:chat.buttons.chat_offline.description`, { lng })}{' '}
          </Typography>
        </div>
      </Row>
      <Row pt="5">
        <input type="hidden" name="chatButtonId" id="chatButtonId" value={buttonId} />
        <div id="salesforceChatButtonDiv" style={{ width: '100%' }}>
          <Button
            id="liveagent_button_online"
            style={{ display: 'none', cursor: 'pointer' }}
            onClick={() => startChat()}
            skin="secondary"
            type="button"
            name="chat_now"
            value="chat_now"
          >
            <FlexBox>
              <ResponsiveImage role="presentation" aspectratio="1" src={chaticon} alt="" width="20px" marginRight="4" style={{ gap: tokens.SwanSemSpace3 }} />
              {t(`${tenant}:chat.buttons.chat_now.title`, { lng })}
            </FlexBox>
          </Button>
          <Button id="ca_liveagent_button_loading" disabled="disabled" style={{ display: 'none' }} type="button" name="chat_loading" value="chat_loading">
            <FlexBox>
              <ResponsiveImage role="presentation" aspectratio="1" src={chaticon} alt="" width="20px" marginRight="4" style={{ gap: tokens.SwanSemSpace3 }} />
              {t(`${tenant}:chat.buttons.chat_loading.title`, { lng })}
            </FlexBox>
          </Button>
          <Button disabled="disabled" id="liveagent_button_offline" style={{ display: 'none' }} type="button" name="chat_offline" value="chat_offline">
            <FlexBox>
              <ResponsiveImage role="presentation" aspectratio="1" src={chaticon} alt="" width="20px" marginRight="4" style={{ gap: tokens.SwanSemSpace3 }} />
              {t(`${tenant}:chat.buttons.chat_offline.title`, { lng })}
            </FlexBox>
          </Button>
        </div>
        <div id="forcedOfflineButton" style={{ display: 'none' }}>
          <Button
            disabled="disabled"
            id="forceOfflineButton"
            style={{ display: !chatEnabled ? 'block' : 'none' }}
            type="button"
            name="chat_offline"
            value="chat_offline"
          >
            <FlexBox>
              <ResponsiveImage role="presentation" aspectratio="1" src={chaticon} alt="" width="20px" marginRight="4" style={{ gap: tokens.SwanSemSpace3 }} />
              {t(`${tenant}:chat.buttons.chat_offline.title`, { lng })}
            </FlexBox>
          </Button>
        </div>
      </Row>
    </Box>
  )
}
export default withTranslation()(ChatContent)
